import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Stack,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import MDTypography from "components/MDTypography";

const PartnerTable = ({
    partners = [],
    onActionClick,
    onViewDetails,
}) => {
    return (
        <TableContainer component={Paper}>
            <Table>
                {/* <TableHead> */}
                <TableRow>
                    <TableCell sx={{ fontWeight: 700, fontSize: "14px" }}>
                        Partner Name
                    </TableCell>

                    <TableCell sx={{ fontWeight: 700, fontSize: "14px" }}>
                        Email
                    </TableCell>

                    <TableCell sx={{ fontWeight: 700, fontSize: "14px" }}>
                        Contact
                    </TableCell>

                    <TableCell sx={{ fontWeight: 700, fontSize: "14px" }}>
                        Partner Type
                    </TableCell>

                    <TableCell sx={{ fontWeight: 700, fontSize: "14px" }}>
                        Pending Count
                    </TableCell>

                    <TableCell
                        align="center"
                        sx={{ fontWeight: 700, fontSize: "14px" }}
                    >
                        Actions
                    </TableCell>
                </TableRow>

                {/* </TableHead> */}

                <TableBody>
                    {partners.length > 0 ? (
                        partners.map((partner) => (
                            <TableRow key={partner._id}>
                                <TableCell>
                                    <MDTypography variant="body2">
                                        {partner.full_name || "-"}
                                    </MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="body2">
                                        {partner.email || "-"}
                                    </MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="body2">
                                        {partner.contact || "-"}
                                    </MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="body2">
                                        {partner?.driver?.is_business ? "Business" : "Individual"}
                                    </MDTypography>
                                </TableCell>

                                <TableCell>
                                    <MDTypography variant="body2">
                                        {partner.pending_count || "-"}
                                    </MDTypography>
                                </TableCell>



                                <TableCell align="center">
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        justifyContent="center"
                                    >

                                        {/* DETAILS */}
                                        <IconButton
                                            onClick={() => onViewDetails(partner)}
                                            sx={{
                                                backgroundColor: "#e3f2fd",
                                                color: "primary.main",
                                                border: "1px solid",
                                            }}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={6} align="center">
                                <MDTypography variant="body2">
                                    No partner data found
                                </MDTypography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PartnerTable;
